import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { getDurationStringHours } from 'src/app/utils/duration-formatter.utils';

@Component({
    selector: 'app-training-group-qualification-status-widget-demo',
    templateUrl: './training-group-qualification-status-widget-demo.component.html',
    styleUrl: './training-group-qualification-status-widget-demo.component.scss',
    standalone: false
})
export class TrainingGroupQualificationStatusWidgetDemoComponent {
  trainingGroupsQualificationData: any[] = [];

  trainingGroupsQualificationColumns: any[]  = [];

  private testData = [
    {
      trainingGroupId: 101,
      trainingGroupName: 'Compliance Basics',
      iddTimeMinutesReached: 450,
      iddTimeMinutesTarget: 900,
    },
    {
      trainingGroupId: 102,
      trainingGroupName: 'Advanced Safety',
      iddTimeMinutesReached: 700,
      iddTimeMinutesTarget: 1000,
    },
    {
      trainingGroupId: 103,
      trainingGroupName: 'Leadership Skills',
      iddTimeMinutesReached: 900,
      iddTimeMinutesTarget: 900,
    },
  ];

  constructor(
    private translateService: TranslateService,
  ) {}

  ngOnInit() {
    this.trainingGroupsQualificationColumns = [
      {
        caption: this.translateService.instant('COMMON.FIELDS.TRAINING-GROUP'),
        dataField: 'trainingGroupName',
        dataType: 'string',
        disableFiltering: true,
      },
      {
        caption: this.translateService.instant('COMMON.FIELDS.PROGRESS'),
        dataField: 'progress',
        dataType: 'string',
        disableFiltering: true,
      },
    ];

    this.trainingGroupsQualificationData = this.testData
      .map((data, index) => ({
        id: index,
        trainingGroupName: data.trainingGroupName,
        trainingGroupId: data.trainingGroupId,
        progress: getDurationStringHours(
          data.iddTimeMinutesReached,
          data.iddTimeMinutesTarget
        ),
        progressPercentage: Math.min(
          Math.round(
            (data.iddTimeMinutesReached / data.iddTimeMinutesTarget) * 100
          ),
          100
        ),
      }))
      .sort((a, b) => a.trainingGroupName.localeCompare(b.trainingGroupName));
  }
}
